module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "sidebar-top img-wrap",
    domProps: {
      "innerHTML": _vm._s(_vm.ad.post_sidebar_top)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unique-info"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("汇眼独具")]), _vm._v(" "), (_vm.uniqueShow) ? _c('ul', {
    staticClass: "unique-list"
  }, _vm._l((_vm.article['汇眼独具']), function(item) {
    return _c('li', [_c('a', {
      staticClass: "article-title",
      attrs: {
        "href": item.guid,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.post_title))]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_c('span', {
      staticClass: "icon"
    }), _vm._v(" "), _vm._l((item.tags), function(tag, index) {
      return _c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (index < 3),
          expression: "index<3"
        }],
        attrs: {
          "href": 'http://www.evhui.com/tag/' + tag.name,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(tag.name))])
    })], 2), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(item.post_modified)))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-special"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("特别策划")]), _vm._v(" "), _c('div', {
    staticClass: "img-wrap",
    domProps: {
      "innerHTML": _vm._s(_vm.ad.index_sidebar_special)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "brand-division"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("品牌专区")]), _vm._v(" "), (_vm.brandShow) ? _c('ul', _vm._l((_vm.article['比亚迪*上汽*北汽*宝马*戴姆勒']), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      staticClass: "brand-icon",
      attrs: {
        "src": _vm.icon[item.tags[0].name],
        "alt": ""
      }
    }), _vm._v(_vm._s(item.tags[0].name))]), _vm._v(" "), _c('a', {
      staticClass: "article-title",
      attrs: {
        "href": item.guid,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.post_title))])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "img-wrap",
    domProps: {
      "innerHTML": _vm._s(_vm.ad.post_sidebar_center)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hot"
  }, [_c('div', {
    staticClass: "nav-wrap"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    class: {
      on: _vm.isPopular
    },
    on: {
      "click": function($event) {
        _vm.getHot('popular')
      }
    }
  }, [_vm._v("热门文章")]), _vm._v(" "), _c('li', {
    class: {
      on: !_vm.isPopular
    },
    on: {
      "click": function($event) {
        _vm.getHot('comment')
      }
    }
  }, [_vm._v("热门评论")])])]), _vm._v(" "), _c('div', {
    staticClass: "hot-content"
  }, [_c('ul', _vm._l((_vm.hot), function(item) {
    return _c('li', [_c('span'), _vm._v(" "), _c('a', {
      staticClass: "category",
      attrs: {
        "href": "http://www.evhui.com/category/info",
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.category[0].name))]), _vm._v(" "), _c('a', {
      staticClass: "title",
      attrs: {
        "href": item.guid,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.post_title))]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_c('span', {
      staticClass: "icon"
    }), _vm._v(" "), _vm._l((item.tags), function(tag) {
      return _c('a', {
        attrs: {
          "href": 'http://www.evhui.com/tag/' + tag.name,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(tag.name))])
    })], 2), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(item.post_modified)))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "link-wrpa"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "link-list"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-wrap"
  }, [_c('span', {
    staticClass: "section-title left-title"
  }, [_vm._v("友情链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partner"
  }, [_c('div', {
    staticClass: "title-wrap"
  }, [_c('span', {
    staticClass: "section-title left-title"
  }, [_vm._v("合作伙伴")])]), _vm._v(" "), _c('ul', {
    staticClass: "partner-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.idccun.com/",
      "target": "_blank"
    }
  }, [_vm._v("互联港湾")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.dnspod.cn/",
      "target": "_blank"
    }
  }, [_vm._v("DNSPod")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bec8bb88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Side.vue
// module id = 576
// module chunks = 1